import React, {useEffect, useState} from 'react';
import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import Footer from '../../components/Footer/Footer';
import {Col, Container, Row, UncontrolledPopover} from 'reactstrap';
import './booths.scss'
import {useTranslation} from 'react-i18next';
import BrowseCategories from "../../components/BrowseCategories/BrowseCategories";
import axios from '../../config/axios-interceptor';
import {Link, useHistory} from "react-router-dom";
import { chunkArray } from '../../utils/utils'

interface IImages {
  url: string;
  name: string;
}

interface IVideos {
  url: string;
  name: string;
}

interface ICompany {
  id: number;
  companyName: string;
  sectorId: number;
  countryId: number;
  city: string;
  packageId: number;
  images: IImages[];
  videos: IVideos[];
  documents: any[];
  description: any;
}

interface ICompanyByPackages {
  standard: ICompany[],
  premium: ICompany[],
  platinium: ICompany[]
}

interface IBooth {
  className: string;
  boothData: ICompany;
  boothImageId?: number;
}

const Booth = ({ className, boothData, boothImageId = 1 }: IBooth) => {
  const history = useHistory();
  const popoverTarget = boothData ? `target-${boothData?.id}` : ''
  const countriesImageNames = ['kosovo', 'albania', 'macedonia', 'montenegro', 'bulgaria', 'holanda', 'bosnia']
  
  const handleBoothClick = (id: number) => {
    history.push(`/booth/${id}`);
  }

  if(!boothData) {
    return <div className={`pt-1 pb-3 px-2 ${className}`}>
      <img className="w-100" src={require('../../assets/images/stand-off.png')} />
    </div>
  }
  
  return (
    <>
      <div
        className={`pt-1 pb-3 px-2 position-relative ${className}`}
        id={popoverTarget}
        onClick={() => handleBoothClick(boothData?.id)}
      >
        <img
          className="position-absolute w-100"
          style={{maxWidth: '11%', top: '7%'}}
          src={require(`../../assets/images/${countriesImageNames[boothData.countryId - 1]}.png`)}
        />

        {boothData?.videos.length > 0 &&
          <div className="position-absolute" style={{width: '27.5%', left: '36.5%', top: '1%'}}>
            <video autoPlay muted loop className="w-100"
              src={boothData?.videos[0].url}
            />
          </div>}

        {boothData?.images?.length > 0 && <img
          className="position-absolute w-100"
          style={{maxWidth: '26%',top: '26.5%', left: '49.8%', transform: `translateX(-50%)`}}
          src={boothData?.images[0].url}
        />}

        <img
          className="w-100"
          src={require(`../../assets/images/StandEmpty-${boothImageId}.png`)}
        />
      </div>

      {(boothData?.companyName || boothData?.images) ? <UncontrolledPopover
        trigger='hover'
        placement="bottom"
        target={popoverTarget}
        style={{width: '220px', boxShadow: '0px 3px 24px 1px rgba(0,0,0,0.9)' }}
        innerClassName="py-2 px-3 app-text-primary rounded"
      >
        {boothData?.images?.length > 0 &&
          <img className="w-100" src={boothData?.images[0].url} />}
        
        {boothData?.companyName ? <h4 className="pt-2 text-center">
          {boothData?.companyName}
        </h4> : null}
      </UncontrolledPopover> : null}
    </>
  )
}

const Booths = () => {
  const {t} = useTranslation();
  const language = localStorage.getItem('language');

  const [sectors, setSectors] = useState([])
  const [categoryId, setCategoryId] = useState<number>(2)
  const [companyPages, setCompanyPages] = useState<ICompanyByPackages[]>([{
    standard: [],
    premium: [],
    platinium: []
  }])
  const [currentPage, setCurrentPage] = useState(1)

  const boothPackages = {
    platinium: 1,
    premium: 2,
    standard: 3
  }

  const goToPage = (page: number) => {
    if(page >= 1 && page <= companyPages.length) {
      setCurrentPage(page)
    }
  }

  const createCompanyPages = (companies: ICompanyByPackages) => {
    const standard = chunkArray(companies.standard, 6);
    const premium = chunkArray(companies.premium, 4);
    const platinium = chunkArray(companies.platinium, 2);

    const max = Math.max(standard.length, premium.length, platinium.length)
    const pages: ICompanyByPackages[] = []

    for(let i = 0; i < max; i++) {
      pages.push({
        standard: standard[i] ? standard[i] : [],
        premium: premium[i] ? premium[i] : [],
        platinium: platinium[i] ? platinium[i] : []
      })
    }

    return pages
  }

  const separateCompaniesByBoothPackage = (companies: ICompany[]) => {
    const companiesByPackage: ICompanyByPackages = {
      standard: [],
      premium: [],
      platinium: []
    }

    companies.forEach((company) => {
      if(company.packageId === boothPackages.standard) {
        companiesByPackage.standard.push(company)
      }

      if(company.packageId === boothPackages.premium) {
        companiesByPackage.premium.push(company)
      }

      if(company.packageId === boothPackages.platinium) {
        companiesByPackage.platinium.push(company)
      }
    });

    //////////////////////////
    // const dummyData = (rnd3, rnd6) => {
    //   return {
    //     id: 1,
    //     companyName: "LinkPlus",
    //     sectorId: rnd3,
    //     countryId: rnd6,
    //     city: "Pristina",
    //     packageId: rnd3  ,      
    //     images: [],
    //     videos: [],
    //     documents: []
    //   };
    // }

    // for(let i = 0; i < 8; i++) { companiesByPackage.standard.push(dummyData(Math.floor(Math.random() * 3) + 1, Math.floor(Math.random() * 6) + 1)) }
    // for(let i = 0; i < 11; i++) { companiesByPackage.premium.push(dummyData(Math.floor(Math.random() * 3) + 1, Math.floor(Math.random() * 6) + 1)) }
    // for(let i = 0; i < 2; i++) { companiesByPackage.platinium.push(dummyData(Math.floor(Math.random() * 3) + 1, Math.floor(Math.random() * 6) + 1)) }
    ////////////
    
    return companiesByPackage;
  }

  const getCompanies = async (categoryId: number) => {
    try {
      const response = await axios.get(`Company/GetAll${categoryId}`);

      if(response?.data?.succeeded) {
        const separatedCompanies = separateCompaniesByBoothPackage(response?.data?.data)
        const pages = createCompanyPages(separatedCompanies)
        setCompanyPages(pages)
        goToPage(1)
      }

    } catch (err) {
      setCompanyPages([])
    }
  }

  const handleCategoryChange = (sectorId: number) => {
    setIsActiveSponsors(false)
    goToPage(1)
    setCategoryId(sectorId)
    getCompanies(sectorId)
  }

  const [isActiveSponsors, setIsActiveSponsors] = useState(true)
  const showSponsors = () => {
    setIsActiveSponsors(true)
    goToPage(1)
    const separatedSponsors = separateCompaniesByBoothPackage(sponsors)
    const pages = createCompanyPages(separatedSponsors)
    setCompanyPages(pages)
    goToPage(1)
    setCategoryId(-5) // use to remove the activnes on other buttons
    // getCompanies(sectorId)
  }

  const getSectors = async () => {
    try {
      const response = await axios.get('Utility/sectors');

      if (response?.data) {
        setSectors(response?.data)
      }
    } catch (err) {
      setSectors([])
    }
  }

  useEffect(() => {
    getSectors()
    //getCompanies(categoryId)
    getSponsors()
  }, [])

  const [sponsors, setSponsors] = useState([])
  const getSponsors = async () => {
    try {
      const response = await axios.get('Company/GetSponsored');

      console.log(response)
      if(response?.data?.succeeded) {
        setSponsors(response?.data?.data)
      } else {
        setSponsors([])
      }
    } catch (err) {
      setSponsors([])
    }
  }

  useEffect(() => {
    if(sponsors.length > 0) {
      showSponsors()
    }
  }, [sponsors]);

  const StandardBooths = () => {
    const companyData = companyPages[currentPage - 1] && companyPages[currentPage - 1].standard;
    const html: any = []
    
    for(let i = 0; i < 6; i++) {
      html.push(<>
        <Booth className="standart-col" boothData={companyData && companyData[i]} boothImageId={i + 1}/>
        {i === 2 &&
          <div className="position-relative d-none d-md-block" style={{width: '8.2%'}}>
            <img className="position-absolute" style={{width: '33px', bottom: '15px', left: 0}} src={require('../../assets/images/tree1.png')}/>
            <img className="position-absolute" style={{width: '33px', bottom: '15px', right: 0}} src={require('../../assets/images/tree2.png')}/>
          </div>}
      </>)
    }

    return (
      <div className="mb-4" style={{backgroundColor: '#eaeef1'}}>
        <Container>
          <div className="d-md-flex text-center">
            {html}
          </div>
        </Container>
      </div>
    )
  }

  const PremiumBooths = () => {
    const companyData = companyPages[currentPage - 1] && companyPages[currentPage - 1].premium;
    const html: any = []
    
    for(let i = 0; i < 4; i++) {
      html.push(<>
        <Booth className="premium-col" boothData={companyData && companyData[i]} boothImageId={8 - i}/>
        {i === 1 &&
          <div style={{width: '12%'}} className="d-none d-md-block">
            <div className="w-100 h-100" style={{backgroundColor: '#dadcdd', clipPath: 'polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%)'}}></div>
          </div>}
      </>)
    }

    return (
      <div className="mb-4" style={{backgroundColor: '#eaeef1'}}>
        <Container>
          <div className="d-md-flex">
            {html}
          </div>
        </Container>
      </div>
    )
  }

  const PlatiniumBooths = () => {
    const companyData = companyPages[currentPage - 1] && companyPages[currentPage - 1].platinium;
    const html: any = []
    
    for(let i = 0; i < 2; i++) {
      html.push(<>
        <Booth className="platinium-col" boothData={companyData && companyData[i]} boothImageId={i + 7} />
        {i === 0 &&
          <div className="position-relative d-none d-md-block" style={{width: '20%'}}>
            <div className="w-100 h-100" style={{backgroundColor: '#dadcdd', clipPath: 'polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%)'}}>
            </div>
            <img className="position-absolute" style={{width: '45px', top: '-20px'}} src={require('../../assets/images/tree2.png')}/>
            <img className="position-absolute" style={{width: '45px', top: '-20px', right: '-3px'}} src={require('../../assets/images/tree1.png')}/>
          </div>}
      </>)
    }

    return (
      <div style={{backgroundColor: '#eaeef1'}}>
        <Container>
          <div className="d-md-flex">
            {html}
          </div>
        </Container>
      </div>
    )
  }

  return (
    <div>
      <Header/>

      <div style={{backgroundColor: '#dadcdd'}}>
        <Link to="/lobby">
          <div className="text-center float-left pb-5 pt-3 pl-3">
            <Button className="bMob2" text={t('btnPres')} type="gradient2" />
          </div>
        </Link>
        <div className="py-5 aMob2" style={{backgroundColor: '#eaeef1'}}>
          <Container>
            <Row className="justify-content-center">
              <Col xs={12} sm="auto" md={4} lg="auto" className="text-center pb-3">
                <Button
                  text={t('boothsBtn1')}
                  type="boothsbtn"
                  onClick={() => showSponsors()}
                    style={{backgroundColor: isActiveSponsors ? '#80C32D' : 'transparent'}}
                />
              </Col>
              {sectors.map((sector: any) => (
                <Col xs={12} sm="auto" md={4} lg="auto" className="text-center pb-3">
                  <Button
                    text={language === 'en' ? sector.enName : sector.name}
                    type="boothsbtn"
                    onClick={() => handleCategoryChange(sector.id)}
                    style={{backgroundColor: categoryId === sector.id ? '#80C32D' : 'transparent'}}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </div>
        
        <StandardBooths />
        <PremiumBooths />
        <PlatiniumBooths />

        <Container>
          <div className="d-flex py-5">
            {currentPage > 1 &&
              <Button
                onClick={() => goToPage(currentPage - 1)}
                text={`< ${currentPage - 1} ` + t('floorBtn')}
                type="gradient1"
                className="mr-auto"
              />}

            {currentPage < companyPages.length &&
              <Button
                onClick={() => goToPage(currentPage + 1)}
                text={t('floorBtn') + ` ${currentPage + 1} >`}
                type="gradient1"
                className="ml-auto"
              />}
          </div>
        </Container>
      </div>

      <BrowseCategories/>
      <Footer/>
    </div>
  );
}

export default Booths;